<div class="backtile">
  <h1 class="title">New Job Listing</h1>
  <br>
  <form [formGroup]="jobDetailForm" (ngSubmit)="submitFormBtnClicked()">
    <mat-form-field appearance="standard">
      <mat-label>Job Title</mat-label>
      <input matInput placeholder="i.e. Angular Developer" formControlName="jobTitle">
      <mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
      <!-- <mat-hint>Hint</mat-hint> -->
    </mat-form-field>

    <mat-form-field appearance="standard">
      <mat-label>Job Description</mat-label>
      <input matInput formControlName="description" placeholder="Describe position...">
      <mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="standard">
      <mat-label>#Tags</mat-label>
      <input matInput formControlName="tags" placeholder="i.e. #FrontendDeveloper">
      <mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="standard">
      <mat-label>Contact</mat-label>
      <input matInput formControlName="contact" placeholder="Name of contact">
      <mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="standard">
      <mat-label>Skill Level</mat-label>
      <input matInput formControlName="skillLevel" placeholder="i.e. Junior Developer">
      <mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="standard">
      <mat-label>Link to Job</mat-label>
      <input matInput formControlName="linkToLI" placeholder="https://....">
      <mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
    </mat-form-field>

    <!-- <mat-divider> -->
      <section class="button-align">
        <div class="button-row"></div>
          <button class="button" mat-raised-button color="primary">SUBMIT</button>
      </section>
    <!-- </mat-divider>  -->
  </form>
  
</div>

   <!-- TODO: convert the below input elements into full-fledged matformfields with inputs inside -->
    <!-- <input type="text" formControlName="description">
    <input type="text" formControlName="tags">
    <input type="text" formControlName="contact">
    <input type="text" formControlName="skillLevel">
    <input type="text" formControlName="linkToLI"> -->
